module.exports = __webpack_public_path__ + "img/error.773410d2.svg";